import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { CONTRATTI, CATEGORIE, PROVINCE } from "@/lib/data";
import { ImageManager } from "./ImageManager";

const NUMS = ["prezzo", "mq", "vani", "camere", "bagni"];
const blank = { titolo: "", riferimento: "", contratto: "Vendita", categoria: "Residenziale", provincia: "FIRENZE", comune: "", zona: "", descrizione: "",
  prezzo: "", mq: "", vani: "", camere: "", bagni: "", immagini: [], in_evidenza: false, pubblicato: true, link_originale: "" };

const toForm = (l) => (l ? { ...blank, ...l, ...Object.fromEntries(NUMS.map((k) => [k, l[k] ?? ""])), immagini: Array.isArray(l.immagini) ? l.immagini : [] } : blank);

const Sel = ({ value, onChange, options, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>{options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
  </Select>
);

export const ListingFormDialog = ({ open, onOpenChange, listing, onSave }) => {
  const [f, setF] = useState(toForm(listing));
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e?.target ? e.target.value : e }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = { ...f };
    NUMS.forEach((k) => { payload[k] = f[k] === "" ? null : parseInt(f[k], 10); });
    delete payload.id; delete payload.created_at; delete payload.updated_at;
    try { await onSave(payload); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="listing-form-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl font-normal">{listing ? "Modifica annuncio" : "Nuovo annuncio"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2 space-y-1.5"><Label>Titolo *</Label><Input required data-testid="lf-titolo" value={f.titolo} onChange={set("titolo")} /></div>
          <div className="space-y-1.5"><Label>Riferimento</Label><Input data-testid="lf-riferimento" value={f.riferimento} onChange={set("riferimento")} /></div>
          <div className="space-y-1.5"><Label>Contratto</Label><Sel testid="lf-contratto" value={f.contratto} onChange={set("contratto")} options={CONTRATTI} /></div>
          <div className="space-y-1.5"><Label>Categoria</Label><Sel testid="lf-categoria" value={f.categoria} onChange={set("categoria")} options={CATEGORIE} /></div>
          <div className="space-y-1.5"><Label>Provincia</Label><Sel testid="lf-provincia" value={f.provincia} onChange={set("provincia")} options={PROVINCE} /></div>
          <div className="space-y-1.5"><Label>Comune</Label><Input data-testid="lf-comune" value={f.comune} onChange={set("comune")} /></div>
          <div className="space-y-1.5"><Label>Zona</Label><Input data-testid="lf-zona" value={f.zona} onChange={set("zona")} /></div>
          <div className="space-y-1.5"><Label>Prezzo (€)</Label><Input type="number" data-testid="lf-prezzo" value={f.prezzo} onChange={set("prezzo")} /></div>
          <div className="space-y-1.5"><Label>Mq</Label><Input type="number" data-testid="lf-mq" value={f.mq} onChange={set("mq")} /></div>
          <div className="grid grid-cols-3 gap-3 sm:col-span-2">
            <div className="space-y-1.5"><Label>Vani</Label><Input type="number" data-testid="lf-vani" value={f.vani} onChange={set("vani")} /></div>
            <div className="space-y-1.5"><Label>Camere</Label><Input type="number" data-testid="lf-camere" value={f.camere} onChange={set("camere")} /></div>
            <div className="space-y-1.5"><Label>Bagni</Label><Input type="number" data-testid="lf-bagni" value={f.bagni} onChange={set("bagni")} /></div>
          </div>
          <div className="sm:col-span-2 space-y-1.5"><Label>Descrizione</Label><Textarea rows={5} data-testid="lf-descrizione" value={f.descrizione} onChange={set("descrizione")} /></div>
          <div className="sm:col-span-2 space-y-1.5"><Label>Foto</Label><ImageManager value={f.immagini} onChange={(v) => setF((s) => ({ ...s, immagini: v }))} /></div>
          <div className="sm:col-span-2 space-y-1.5"><Label>Link annuncio originale</Label><Input data-testid="lf-link" value={f.link_originale} onChange={set("link_originale")} /></div>
          <label className="flex items-center gap-3 text-sm"><Switch data-testid="lf-evidenza" checked={f.in_evidenza} onCheckedChange={set("in_evidenza")} /> In evidenza in homepage</label>
          <label className="flex items-center gap-3 text-sm"><Switch data-testid="lf-pubblicato" checked={f.pubblicato} onCheckedChange={set("pubblicato")} /> Pubblicato</label>
          <div className="sm:col-span-2 flex justify-end gap-3 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="lf-cancel">Annulla</Button>
            <Button type="submit" disabled={busy} data-testid="lf-submit">{busy ? "Salvataggio…" : "Salva annuncio"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
